import { OperationProblem } from '../../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'elma365-version-status';

export const DEFAULT_ITEM = {
  title: '',
  subtitle: '',
  description: '',
  problem: undefined as OperationProblem | null | undefined,
  modal: false,
};
